import React from 'react';
import { PageSteps } from '../NewHeader';
import { AlertModal } from '@repo/ui/components';
import { cn } from 'types';

export interface ICancelReserveOrderModalProps {
  modalStatus: boolean;
  closeModalClick(): void;
  confirmReserveCancelClick(): void;
  currentStep?: PageSteps;
}

export const CancelReserveOrderModal = (props: ICancelReserveOrderModalProps) => {
  return (
    <AlertModal
      className="w-fit"
      open={props?.modalStatus}
      onCloseClick={props.closeModalClick}
      title={'Er du sikker på at du vil avbryte reservasjon?'}
      description={'Denne handlingen kan ikke angres.'}
      actionsList={[
        {
          actionLabel: 'Bekreft',
          actionMethod: () => props.confirmReserveCancelClick(),
          actionClassNames: cn(
            'font-bold py-[1.125rem] px-[1.875rem] leading-[100%] border-[3px] bg-white focus:ring-0 ',
            {
              'border-turquoise focus:border-turquoise enabled:hover:bg-turquoise':
                props.currentStep === PageSteps.START,
              'border-darkBlue focus:border-darkBlue enabled:hover:bg-darkBlue text-black hover:text-white':
                props.currentStep !== PageSteps.START,
            }
          ),
        },
        {
          actionLabel: 'Avbryt',
          actionMethod: () => props.closeModalClick(),
          actionClassNames: cn('font-bold py-[1.125rem] px-[1.875rem] leading-[100%] border-none', {
            'bg-turquoise enabled:hover:bg-teal': props.currentStep === PageSteps.START,
            'bg-darkBlue enabled:hover:bg-darkNavyBlue text-white': props.currentStep !== PageSteps.START,
          }),
        },
      ]}
    />
  );
};
